import { render, staticRenderFns } from "./AttachOrderPopup.vue?vue&type=template&id=e402c394&"
import script from "./AttachOrderPopup.vue?vue&type=script&lang=js&"
export * from "./AttachOrderPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports